
import { Vue, Component, Prop } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import { dicSelect, dicTypeSelect } from "@newview/ui";
@Component({
  name: "searchCom",
  components: {
    dicSelect,
    dicTypeSelect,
  },
})
export default class searchCom extends BaseVue {
  @Prop({ default: () => [] }) searchSetting!: Object; //搜索条件列表
 
  //format:string= "yyyy-MM-dd";
  handleSearch() {
    let searchParam = JSON.parse(JSON.stringify(this.searchSetting));
    let param = {};
    for (const item of searchParam) {
      param[item.key] = item.value ? item.value : "";
      if (item.type == "date") {
        param[item.key] = this.isNull(item.value)
          ? ""
          : this.ForMatDate(new Date(item.value), "yyyy-MM-dd");
      }
    }
    this.$emit("on-search", param);
  }

  getparams() {
    let searchParam = JSON.parse(JSON.stringify(this.searchSetting));
    let param = {};
    for (const item of searchParam) {
      param[item.key] = item.value ? item.value : "";
      if (item.type == "date") {
        param[item.key] = this.isNull(item.value)
          ? ""
          : this.ForMatDate(new Date(item.value), "yyyy-MM-dd");
      }
    }
    return param;
  }
  dateRangChange(value,item){
    item.value = value  
  }

  resetValue(){
    this.searchSetting = this.Baselinq.from(this.searchSetting).select(e=>{
      e.value = ""
      return e
    }).toArray()
    this.$forceUpdate()
  }


 onCreate(newOptionValue: string) {
  debugger
    const activeItem = (this.searchSetting as any[]).find(
      (item) => item.type === 'select' && item.allowCreate
    );

    if (activeItem?.children) {
      // 根据现有数据结构动态适配字段名
      const isValueTextFormat = activeItem.children.some(
        (child: any) => 'value' in child && 'text' in child
      );

      const newOption = isValueTextFormat
        ? { value: newOptionValue, text: newOptionValue }
        : { code: newOptionValue, name: newOptionValue };

      activeItem.children.push(newOption);
      activeItem.value = newOptionValue;
    }
  }
}
